var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.wrapper},[_c('TheVisualWebsiteOptimizer'),(_vm.isRedirecting)?_c('BaseLoading',{attrs:{"full-screen":""}}):(_vm.env === 'cn')?_c('CnLanding'):_c('SummerLandingPage')],1)}
var staticRenderFns = []

export { render, staticRenderFns }